import { _ } from "../../../../polyglot/polyglot.js";
import OldSpinnerWidget from "../../../../../deprecated/OldSpinnerWidget/OldSpinnerWidget.js"; // eslint-disable-line import-x/no-deprecated -- todo: migrate to new spinner

/**
 * Strategy to render the content of a {@link ListSourceWidget}.
 *
 * @abstract
 * @param {Renderable} [trailingWidget] - Optional trailing widget to
 *   append at the end of the list of items
 * @param {string} [cssClass] - Additional CSS class to append to the
 *   root of the widget
 * @param {string} messageForEmptyContent - Message that will be shown when there is no data to list
 */
export default class AbstractListStrategy {
	constructor({
		trailingWidget,
		cssClass,
		messageForEmptyContent = _("No item found matching your criteria"),
	} = {}) {
		// eslint-disable-next-line import-x/no-deprecated -- todo: migrate to new spinner
		this._spinner = new OldSpinnerWidget({
			dark: true,
			size: 64,
		});

		this._trailingWidget = trailingWidget;
		this._cssClass = cssClass;
		this._messageForEmptyContent = messageForEmptyContent;
	}

	setListSourceWidget(listSourceWidget) {
		// This avoids circular references when serializing this as JSON
		// as it is done in Storybook
		Object.defineProperty(this, "_listSourceWidget", {
			enumerable: false,
			value: listSourceWidget,
			writable: true,
		});
	}

	cssClass() {
		return [this.baseCss(), this._cssClass];
	}

	baseCss() {
		return "list-widget";
	}

	renderEmptyOn(html) {
		html.render(
			this._trailingWidget
				? this.itemsRenderer({ items: [] })
				: this._messageForEmptyContent,
		);
	}

	renderLoadingOn(html) {
		return html.render(this._spinner);
	}

	/**
	 * Method returning a renderable holding a collection of items.
	 * Candidates are html.ul or html.table for example.
	 * It is *very* important that the rendering of one individual item is done
	 * via `listSourceWidget.makeItemRenderable` and not directly by invoking
	 * `this.makeItemRenderable` to allow a potential wrapper to intercept the
	 * item creation.
	 *
	 * @abstract
	 * @return {function(htmlCanvas): void}
	 */
	itemsRenderer({ items: _items }) {
		throw new Error("Should be overridden");
	}

	/**
	 * Method creating, and returning, a tag brush containing the item
	 * rendering. It is *very* important that this method is invoked
	 * from the ListSourceWidget, and not from `this.itemsRenderer` to allow
	 * a potential wrapper to intercept this method.
	 *
	 * @abstract
	 * @return {tagBrush}
	 */
	makeItemRenderable({ html: _html, item: _item, index: _index }) {
		throw new Error("Subclass responsibility");
	}
}
